import { ArticleHeading4, TooltipDesktop, UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import { Link } from 'shared/components/InteractiveTypography';
import { useCAForCard } from 'shared/hooks/useCAForCard';
import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { getLevelName, getTooltipContent } from './internal/utils';
import type { PublisherLevel, PublisherLevelViewProps } from './types';

import styles from './PublisherLevelView.css';

const supportedLevels = new Set<PublisherLevel>(['experienced', 'professional']);

export const PublisherLevelView: FC<PublisherLevelViewProps> = props => {
  const { level } = props;

  const caForCard = useCAForCard();

  if (!supportedLevels.has(level)) {
    return null;
  }

  const levelName = getLevelName(level);
  const tooltipContent = getTooltipContent(level);

  return (
    <TooltipDesktop
      placement="left"
      theme="white"
      title={
        <div className={styles['tooltip']}>
          <ArticleHeading4 as="h4">{levelName}</ArticleHeading4>
          <Link
            behaviour="hover_primary_to_primary_hover"
            href="https://support.cian.ru/ru/knowledge_base/art/229/cat/69/"
            track={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'honest_work' })}
            onClick={stopPropagation}
          >
            Участник программы «Работаю честно»
          </Link>
          <UIText2>{tooltipContent}</UIText2>
        </div>
      }
    >
      <img
        alt={`Работаю честно: уровень ${level}`}
        height={16}
        src={require(`./internal/assets/level_${level}.svg`)}
        width={16}
      />
    </TooltipDesktop>
  );
};
